<template>
  <tbody>
  <tr :class="{more_info: isEditable}" @click="toggleOpen">
    <td :data-th="'Zdroj obsahu' |translate" class="first_data" >{{ item.hostname }}</td>
    <td :data-th="'Operátor' |translate" class="first_data" >{{ item.operator_name }}</td>
    <td :data-th="'Obecný zdroj' |translate" class="first_data">
      <img class="is_set" src="../../../../assets/images/is-set.svg" alt="Ano"
           v-if="item.global"/>
    </td>
    <td :data-th="'IP adresa' |translate" class="first_data">{{ item.ip }}</td>
    <td :data-th="'Virtuální zdroj' |translate" class="first_data">
      <img class="is_set" src="../../../../assets/images/is-set.svg" alt="Ano"
           v-if="item.virtual"/>
    </td>
    <td :data-th="'Vytížitelnost zdroje' |translate" class="first_data">{{ item.utilization_factor}}</td>
    <td :data-th="'Váha' |translate" class="first_data">{{ item.weight}}</td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="isEditable"
            class="btn btn_action btn_delete"
                        :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteContentSource">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
  <tr v-if="isOpen && isEditable" class="more_info_content open">
    <td class="first_data">

    </td>
    <td></td>
    <td></td>
    <td></td>
    <td>
      <text-input
        id="new-content-source-weight"
        :required="true"
        type="number"
        ref="localitycontentsourceweightref"
    >
      <translate class="translate">Váha</translate>
    </text-input>
    </td>
    <td><p>
      <input
          class="btn"
          type="submit"
          :value="'Uložit' | translate"
          @click.stop.prevent="emitUpdateIpPrefix">
    </p></td>
    <td></td>
  </tr>
  </tbody>
</template>

<script>
export default {
  name: "ContentSourceRow",
  props: {
    item: Object,
    isEditable: Boolean,
  },
  data: function() {
    return {
      isOpen: false,
      newValue: this.item.content_source,
    }
  },
  methods: {
    toggleOpen(){
      if(this.isEditable){
        this.isOpen = !this.isOpen;
      }
    },
    emitDeleteContentSource() {
      this.$emit('deleteContentSource', String(this.item.id));
    },
    close(){
      this.isOpen = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/localities/locality/ContentSourceRow.vue